<div *transloco="let t" class="mx-auto w-[min(40rem,100%)]">
  @if (strategy()) {
    <app-strategy-advanced-settings
      [strategy]="strategy()!"
      [strategyGroup]="strategyGroup()"
      [advancedSettings]="advancedSettings()"
    />
  }
</div>
